import { render } from "./PageDescription.vue?vue&type=template&id=da9cbcde"
import script from "./PageDescription.vue?vue&type=script&lang=js"
export * from "./PageDescription.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__